module.exports = __webpack_public_path__ + "img/nav-design-diamondrings@2x.e4dfc87.webp";